import React, { useEffect, useState, useRef } from "react";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import OwlCarousel from "react-owl-carousel3";
import benefiticon from "../../assets/images/Benefits icon 1 (1).webp"
const services = [
  {
    id: 1,
    title: "Increased Productivity",
    colorClass: "yellow-service",
    dotClass: "yellow-dot",
    color: "#FFC250",
    points: "Chatbots can help businesses automate tasks, such as answering frequently asked questions, freeing up human resources for more complex tasks.",
  },
  {
    id: 2,
    title: "Improved Customer Experience",
    colorClass: "red-service",
    dotClass: "red-dot",
    color: "#E9536C",
    points: "Chatbots can provide 24/7 customer support, enabling customers to get help whenever they need it.",
  },
  {
    id: 3,
    title: "Convenience",
    colorClass: "pink-service",
    dotClass: "pink-dot",
    color: "#F4B1B8",
    points: "Chatbots can help customers quickly find what they're looking for, such as product information or order status, without having to wait for a human representative.",
  },
  {
    id: 4,
    title: "Personalized Interactions",
    colorClass: "blue-service",
    dotClass: "blue-dot",
    color: "#1EACC0",
    points: "Chatbots can use customer data to offer personalized recommendations and offers, enhancing the customer experience.",
  },
  {
    id: 5,
    title: "Cost-Effective",
    colorClass: "yellow-service",
    dotClass: "yellow-dot",
    color: "#FFC250",
    points: "Chatbots can reduce the need for human customer support agents, potentially lowering costs for businesses.",
  },
];
const ChatbotsBenifits = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const sectionRefs = useRef([]);

  useEffect(() => {
    const options = {
      root: null,
      rootMargin: "0px 0px -20% 0px", // triggers earlier when top is at 40% of viewport
      threshold: 0.5,
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const index = Number(entry.target.getAttribute("data-index"));
          setActiveIndex(index);
        }
      });
    }, options);

    sectionRefs.current.forEach((ref) => {
      if (ref) observer.observe(ref);
    });

    return () => {
      sectionRefs.current.forEach((ref) => {
        if (ref) observer.unobserve(ref);
      });
    };
  }, []);

  return (
    <div>
       <div className="benefitsfont">benefits</div>
       <div className="benefithead">Chatbots</div>
       <div className="mb-5">
                       <div className="container-fluid">
                         <div className="row">
                           <div className="col-lg-12">
                             <div className="benefitwidth">
                               <OwlCarousel
                                 className="owl-theme"
                                 loop
                                 autoplay={true}
                                 items="1"
                                 dots={false}
                                 smartSpeed={2000}
                                 nav={true}
                                 navText={[
                                   `<i class="fa fa-chevron-left"></i>`,
                                   `<i class="fa fa-chevron-right"></i>`,
                                 ]}
                                 margin={20}
                                 // center={true}
                                 autoplayTimeout={5000}
                                 responsive={{
                                   360: {
                                     items: "1",
                                   },
                                   414: {
                                     items: "1",
                                   },
                                   670: {
                                     items: "2",
                                   },
                                   992: {
                                     items: "3",
                                   },
         
                                   1200: {
                                     items: "3",
                                   },
                                 }}
                               >
                                 {services.map((item, index) => {
                                   return (
                                    <div className="position-circle">
                                       <img  src={benefiticon} className='benefiticon' alt='icon'/>
                                       <div className="border-dot1">
                                    <div className="orange-circle">
          
                                    </div>
                                    </div>
                                    <div className="carousel-wapp-card">
                                     
    <div>
      <div className="carouselwapp">
    {item.title}
      </div>
      <div className="carousel-para">
    {item.points}
      </div>
    </div>
    
                                    </div>
                                    </div>
                                    
                                   );
                                 })}
                               </OwlCarousel>
                             </div>
                           </div>
                         </div>
                       </div>
                     </div>
    </div>
  );
};

export default ChatbotsBenifits;
